
<template>
  <div class="tougao newsContent scrollView">


    <div class="c-loading" v-if="loading">
      <div class="c-loading-c">
        <img src="../assets/loading.svg">
        <div>加载中...</div>
      </div>

    </div>

    <div v-lese>
      <img class="banner" v-if="banner" :src="banner"/>

      <div class="rank-i text-overflow" v-for="(d,i) in list" @click="openContent(d.art_id)">
        <span :class="{one:i==0,two:i==1,three:i==2}">{{i+1}}</span>
        <div>{{d.title}}</div>
      </div>

    </div>



  </div>
</template>

<style >
  @import '../assets/css/listcomponentscss.css';
  .rank-i{ padding: 0 20px; font-size: 17px;  height: 60px; overflow: hidden; display: flex !important;align-items: center; line-height: 30px; position: relative; border-bottom: #fff 1px solid}
  .rank-i:after{ content: " "; width: 100%; height: 1px; position: absolute; left: 0; bottom:0.5px; background-color: #dbdcdd}
  .rank-i div{ height: 30px; line-height: 30px; overflow: hidden}
  .rank-i span{ font-weight: bold; padding-right: 6px; color: #06daa0
  }
  .rank-i .one{color:red}
  .rank-i .two{color: #ff7300
  }
  .rank-i .three{color: #ffbc24
  }
  .banner{ display: block; width: 100%}
</style>

<script>

// @ is an alias to /src

import request from "../utils/request";
import { Toast } from 'vant';
import utils from "../utils";
var $ = require("jquery");
export default {
  name: 'Home',
  data(){
    return{
      banner:"",
      loading: true,
      list:[]



    }
  },
  created() {
    this.getData();
    document.title="看度时政-作文榜单";



    request.getWeixinShanre(location.href,(s_res)=>{
      let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
      let shareconfig = {appId,timestamp,nonceStr,signature};
      if(utils.is_weixin()){
        let sharedata = {
          title:"看度时政-作文榜单",
          desc:"作文投稿请下载看度时政APP",
          link:location.href,
          imgUrl:thumb
        };
        utils.setWeiXinShare(sharedata,shareconfig,false)

      }
    });


  },
  methods:{
    getData(){
      request.zwRank(this.$route.params.id,res=>{
          console.log(res)
        if (res && res.code == 200) {
          this.banner = res.data.ac_icon;
          this.list = res.data.list;
          this.loading = false;





        }else{
          alert("获取数据失败")
        }
      })
    },
    openContent(id){
      location.href = 'http://img2.yitoutiao.net/t/index.html#zwContent&id='+id;
    }
  },

}
</script>
